export default __webpack_public_path__ + "static/media/breakthrough.be14f53e.png";